import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { PermissionModel } from '../../shared/models/navigation.model';
import { getRoute } from '../../shared/routes/helper';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
    selector: 'app-sidenav-list',
    templateUrl: './sidenav-list.component.html',
    styleUrls: ['./sidenav-list.component.scss'],
    animations: [
        trigger('indicatorRotate', [
            state('collapsed', style({ transform: 'rotate(0deg)' })),
            state('expanded', style({ transform: 'rotate(180deg)' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
        ])
    ],
    standalone: false
})
export class SidenavListComponent implements OnInit {

  @HostBinding('attr.aria-expanded') ariaExpanded;
  @Input() item: PermissionModel;
  @Input() depth = 0;
  expanded = false;

  constructor(private readonly router: Router, private readonly snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.expanded = this.isActive(this.item);
    this.ariaExpanded = this.expanded;
  }

  isActive(item: PermissionModel): boolean {
    if (getRoute(item.viewKey) === this.router.url) {
      return true;
    } else {
      return item.children.some(c => this.isActive(c));
    }
  }

  onItemSelected(item: any): void {
    if (!item.children || !item.children.length) {
      this.goTo(item);
    }

    if (item.children && item.children.length) {
      this.expanded = !this.expanded;
    }
  }

  private goTo(item: PermissionModel): void {
    const route = getRoute(item.viewKey);
    if (route) {
      localStorage.setItem('permissionDescription', item.permissionDescription);
      void this.router.navigate([route]);
    } else {
      this.snackBar.open('View does not exist', '', {
        duration: 2000,
        panelClass: ['red-snackbar'],
        horizontalPosition: 'right',
        verticalPosition: 'top'
      });
    }
  }
}
